export function upperCaseAndAddDash(words: string) {
    return words?.toUpperCase()?.split(' ')?.join('-');
}
